import '@mui/x-charts/themeAugmentation';

import { createTheme } from '@mui/material/styles';
import { BASE_COLORS } from 'lib/functions/const/colors';

const theme = createTheme({
  palette: {
    primary: { main: BASE_COLORS.blue },
    secondary: { main: BASE_COLORS.white },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          color: BASE_COLORS.blue,
          '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        },
      },
    },
    MuiChartsAxis: {
      styleOverrides: {
        root: {
          '& .MuiChartsAxis-tick': {
            fill: '#E0E0E0',
          },
          '& .MuiChartsAxis-line': {
            stroke: '#666',
          },
        },
      },
    },
    MuiChartsGrid: {
      styleOverrides: {
        root: {
          stroke: '#333',
          strokeOpacity: 0.3,
        },
      },
    },
    MuiChartsLegend: {
      styleOverrides: {
        root: {
          fontFamily: " 'Nunito', sans-serif",
          fontSize: '14px',
          display: 'none',
        },
      },
    },
    MuiChartsTooltip: {
      styleOverrides: {
        root: {
          fontFamily: " 'Nunito', sans-serif",
          fontSize: '14px',
          fontWeight: 300,
        },
        paper: {
          fontFamily: " 'Nunito', sans-serif",
          fontSize: '14px',
          fontWeight: 300,
        },
        table: {
          fontFamily: " 'Nunito', sans-serif",
          fontSize: '14px',
          fontWeight: 300,
        },
      },
    },
    MuiChartsSurface: {
      styleOverrides: {
        root: {
          '& .MuiAreaElement-root': {
            opacity: 0.2,
          },
        },
      },
    },
  },
  typography: {
    fontFamily: " 'Nunito', sans-serif",

    h1: {
      fontSize: '1.8rem',
      fontWeight: 500,
      margin: 0,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      margin: '0px 0px',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 400,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 400,
      margin: '15px 0px',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 200,
      margin: '15px 0px',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 200,
      margin: '5px 0px',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 200,
    },
  },
});

export default theme;
